import { useQueryClient } from '@tanstack/react-query';

import {
  DrawerContent,
  useDrawerInstance,
  notify,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { getClusterEdgeLocationsQueryKey } from 'hooks/queries/omni/useGetClusterEdgeLocationsQuery';

import { EdgeLocationOnboarding } from '../../_components/EdgeLocationOnboarding';
import { EdgeLocationDrawerFooter } from '../../_components/EdgeLocationDrawerFooter';

type EdgeLocationOnboardingStepProps = {
  clusterId: string;
  edgeLocationId?: string;
  hideSuccessNotification?: boolean;
};

export const EdgeLocationOnboardingStep = ({
  clusterId,
  edgeLocationId,
  hideSuccessNotification = false,
}: EdgeLocationOnboardingStepProps) => {
  const { close } = useDrawerInstance();
  const queryClient = useQueryClient();

  if (!edgeLocationId) {
    return null;
  }

  const handleSubmit = () => {
    close();

    // refetch edge locations in order to retrieve updated state
    queryClient.invalidateQueries({
      queryKey: getClusterEdgeLocationsQueryKey({ clusterId }),
    });

    if (!hideSuccessNotification) {
      notify.success('Edge location created successfully');
    }
  };

  return (
    <Stack height="100%">
      <DrawerContent sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <Typography
          variant="L12R"
          color={tokens.theme.fg.structural.secondary}
          mb={8}
        >
          Create edge location
        </Typography>
        <EdgeLocationOnboarding
          clusterId={clusterId}
          edgeLocationId={edgeLocationId}
        />
      </DrawerContent>
      <EdgeLocationDrawerFooter
        submitButtonLabel="Done"
        showSubmitIcon={false}
        submitButtonTestId="done-button"
        onClose={() => close()}
        onSubmit={handleSubmit}
      />
    </Stack>
  );
};
